<template>
  <div :style="backgroundImageStyle">
    <div id="video-background">
      <iframe 
        src="https://player.vimeo.com/video/1095968815?badge=0&autoplay=1&background=1&quality=1080p&api=1&player_id=1&dnt=1" 
        frameborder="0" 
        allow="autoplay"
        webkitallowfullscreen="false" 
        mozallowfullscreen="false" 
        allowfullscreen="false"
        playsinline
        webkit-playsinline
        style="pointer-events: none;"
      ></iframe>
    </div>
    <div class="under-header contentsLayout">
      <div v-if="iconMenu && iconMenu.length" class="grid">
        <div
            v-for="(item, index) in iconMenu"
            :key="item.id"
            :class="getColumnClass(index)"
        >
            <a :href="`/pages/${item?.slug}`" @click.prevent="goToPage(item?.slug, $refs.slideContent)" class="relative block h-full" :style="getItemStyleWithFallback(item, index)" :title="item?.title || 'Navigate to page'">
              <div class="absolute w-full h-full flex flex-column align-items-center bg-black-alpha-10 p-5">
                  <div class="wrapper">
                    <div class="icon-animation relative">
                      <svg :class="{ 'loaded': isActive }" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="175px" height="175px" 
                        xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="absolute">
                          <g>
                            <g>
                              <path d="M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7"/>
                          </g>
                        </g>
                      </svg>
                      <img 
                        v-if="item.iconImage" 
                        :src="resolveImageUrl(item.iconImage)" 
                        :alt="item?.title  + ' Icon' || 'Untitled' + ' Icon'"
                        :class="{ 'loaded': isActive }"
                        @load="handleImageLoad"
                      >
                    </div>
                    <h3 v-if="item.altTitle || item.title" class="text-white text-center">{{ item?.altTitle || item?.title || 'Untitled' }}</h3>
                  </div>
              </div>
            </a>
        </div>
      </div>
      <div v-else class="flex justify-content-center align-items-center p-6">
        <i class="pi pi-book text-4xl text-500 mr-3"></i>
        <span class="text-500 text-xl">No pages found</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useNavigation } from '../composables/useNavigation.js';
import { useCommonStyles } from '../composables/useCommonStyles.js';
import { useMediaHelpers } from '../composables/useMediaHelpers.js';

const props = defineProps({
  page: Object,
  settings: Object,
  isActive: {
    type: Boolean,
    default: false
  }
});

const { resolveImageUrl } = useMediaHelpers();

const handleImageLoad = (event) => {
  event.target.classList.toggle('loaded', props.isActive);
};

// Get navigation functionality
const { goToPage, pagesList, iconMenu } = useNavigation();
const { backgroundImageStyle, getItemStyle } = useCommonStyles(props);
const fallbackColors = ['#7F73E6', '#4991FF', '#00B3E8'];
const getItemStyleWithFallback = (item, index) => getItemStyle(item, index, fallbackColors);

const getColumnClass = (index) => {
    return 'p-0 col col-3'
};

</script>
